"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _classnames = _interopRequireDefault(require("classnames"));
var _collapsibleShared = require("@ingka/collapsible-shared");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Collapsible = props => {
  const {
    children,
    className,
    expanded = false,
    prefix = '',
    id,
    onTransitionEnd,
    focusOnExpanded = false,
    ...other
  } = props;
  const contentWrapper = (0, _react.useRef)();
  const [maxHeight, setMaxHeight] = (0, _react.useState)((0, _collapsibleShared.getDefaultMaxHeight)(expanded));
  (0, _react.useEffect)(() => {
    setMaxHeight((0, _collapsibleShared.getNextMaxHeight)(expanded, maxHeight, contentWrapper.current));
  }, [expanded]);
  (0, _react.useEffect)(() => {
    (0, _collapsibleShared.prepareAnimateToExpanded)(expanded, maxHeight, contentWrapper.current, setMaxHeight);
  }, [maxHeight]);
  (0, _react.useEffect)(() => {
    setMaxHeight((0, _collapsibleShared.getDefaultMaxHeight)(expanded));
  }, []);
  const baseClass = `${prefix}collapsible`;
  const classes = (0, _classnames.default)(baseClass, className);
  return _react.default.createElement("div", _extends({
    id: id,
    className: classes,
    style: {
      maxHeight
    },
    onTransitionEnd: e => {
      (0, _collapsibleShared.handleTransitionEnd)(expanded, focusOnExpanded, contentWrapper.current, e, setMaxHeight, onTransitionEnd);
    },
    "aria-hidden": !expanded,
    role: "region",
    tabIndex: (0, _collapsibleShared.getTabIndex)(expanded, focusOnExpanded),
    ref: contentWrapper
  }, other), children);
};
var _default = Collapsible;
exports.default = _default;